import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import eventActions from '../../redux/event/actions'
import ContentEditEvents from './Content_edit_event'
class EditEvent extends Component {
    constructor(props) {
        super(props)
    }
    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props
        return (
            <div>
                {visible && (
                    <Modal
                        visible={true}
                        onOk={() => this._handleOK()}
                        onCancel={() => this._handleCancel()}
                        width={window.innerWidth / 2}
                        centered={false}
                        footer={[]}
                    >
                        <ContentEditEvents />
                    </Modal>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.currentUser,
        visible: state.eventReducer.visibleEditModal,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(eventActions.action.visibleEditModal(false))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditEvent)
